import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import GlobalSetting from "../pages/Global Setting";
import AddBannerOffer from "../pages/Offerandbannermanagement/Add";
import Offerandbannermanagement from "../pages/Offerandbannermanagement/List";
import OfferAndBannerView from "../pages/Offerandbannermanagement/View";
import CategoryManagement from "../pages/CategoryManagement/List";
import AddCategory from "../pages/CategoryManagement/Add";
import CategoryView from "../pages/CategoryManagement/View";
import ProductManagement from "../pages/ProductManagement/List";
import AddProduct from "../pages/ProductManagement/Add";
import ProductView from "../pages/ProductManagement/View";
import AddDealer from "../pages/DealerManagement/Add";
import DealerView from "../pages/DealerManagement/View";
import DealerManagement from "../pages/DealerManagement/List";
import CustomerManagement from "../pages/CustomerManagement/List";
import AddCustomer from "../pages/CustomerManagement/Add";
import CustomerView from "../pages/CustomerManagement/View";
import CmsPage from "../pages/cms/List";
import AddEditCms from "../pages/cms/Add";
import ViewCms from "../pages/cms/View";
import FaqList from "../pages/faq/List";
import AddEditFaq from "../pages/faq/Edit";
import ViewFaqDetail from "../pages/faq/View";
import OrderManagement from "../pages/OrderManagement/List";
import OrderManagementView from "../pages/OrderManagement/View";
import DeliveryPartnerManagement from "../pages/DeliveryPartnerManagement/List";
import AddDeliveryPartner from "../pages/DeliveryPartnerManagement/Add";
import DeliveryPartnerManagementView from "../pages/DeliveryPartnerManagement/View";
import PaymentManagement from "../pages/PaymentManagement/List";
import PaymentManagementView from "../pages/PaymentManagement/View";
import TimeSlot from "../pages/TimeSlot/List";
import AddTimeSlot from "../pages/TimeSlot/Add";
import TimeSlotView from "../pages/TimeSlot/View";
import EmailTemplateList from "../pages/EmailTemplateManagement/List";
import AddEmail from "../pages/EmailTemplateManagement/Add";
import ViewEmail from "../pages/EmailTemplateManagement/View";
import NotificationManagement from "../pages/NotificationManagement/List";
import SubAdminManagementList from "../pages/SubadminManagement/List";
import ViewSubAdminManagement from "../pages/SubadminManagement/viewSubadmin";
import AddEditSubadmin from "../pages/SubadminManagement/addEditSubadmin";
import RateAndReviewList from "../pages/RateAndReviewManagement/List";
import ViewRateAndReview from "../pages/RateAndReviewManagement/viewRateAndReview";
import ReportsAndAnalytics from "../pages/ReportsAndAnalytics/List";
import List from "../pages/DealerCommissionManagement/List";
import View from "../pages/DealerCommissionManagement/View";
import LanguageList from "../pages/LanguageManagement/List";
import AddLanguage from "../pages/LanguageManagement/Add";
import { Loader } from "../components/customLoader";
import CustomerQueryManagement from "../pages/CustomerQueryManagement/List";
import CustomerQueryView from "../pages/CustomerQueryManagement/View";
import CurrencySettings from "../pages/CurrencyManagement/List";
import NotificationEdit from "../pages/NotificationManagement/Add";
import DashboardAppPage from "../pages/dashboard/DashboardPage";
import { element } from "prop-types";
import NotificationView from "../pages/NotificationManagement/View";
import { getFirstPermittedRoute } from "../pages/auth/getPermissionRoute";
import DealerReport from "../pages/ReportsAndAnalytics/Reports/DealerReport";
import DriverReport from "../pages/ReportsAndAnalytics/Reports/DriverReport";
import OrderReport from "../pages/ReportsAndAnalytics/Reports/OrderReport";
import RefundCancellationReport from "../pages/ReportsAndAnalytics/Reports/Refund&CancellationReport";
import UserIssueReport from "../pages/ReportsAndAnalytics/Reports/UserIssueReport";
import DemographicReport from "../pages/ReportsAndAnalytics/Reports/DemographicReport";
import RevenueReport from "../pages/ReportsAndAnalytics/Reports/RevenueReport";
import SalesTrendsReport from "../pages/ReportsAndAnalytics/Reports/SalesTrendsReport";

const ChangePassword = lazy(() => import("../pages/auth/ChangePassword"));

//CMS............................................................ ............................
// const CmsPage = lazy(() => import("../pages/cms/List"));
// const ViewCms = lazy(() => import("../pages/cms/View"));
// const AddEditCms = lazy(() => import("../pages/cms/Add"));

//MyAccount........................................................................................
const MyAccount = lazy(() => import("../pages/myAccount/MyAccount"));

const PrivateLayout = lazy(() => import("../layouts/private"));
const Page404 = lazy(() => import("../pages/error/Page404"));
const DashboardPage = lazy(() => import("../pages/dashboard/DashboardPage"));
const LoadingFallback = <div><Loader /></div>;

const makeLazyComponent = (importFunc) => (
  <Suspense fallback={LoadingFallback}>{importFunc()}</Suspense>
);

const MainRouting = ({ permissions }) => {
  let dataparmition = permissions?.permission || {};
  let data = Object.keys(dataparmition);
  const hasPermission = (permissionKey) => {
    return dataparmition && data.includes(permissionKey);
  };

  const routes = [
    {
      element: <PrivateLayout />,
      errorElement: <Page404 />,
      children: [

        {
          path: "settings",
          element: makeLazyComponent(() => <GlobalSetting />),
        },

        // { path: "*", element: <Navigate to="/dashboard" />, index: true },
        // ...(hasPermission("Dashboard")
        // ? [
        // {
        //   path: "/dashboard",
        //   element:  <DashboardPage />,
        // },
      // ]
      // : []),
      ...(hasPermission("Dashboard")
     ? [{
        path: "/dashboard",
        children: [
          {
            index: true,
            element: makeLazyComponent(() => <DashboardAppPage />),
          },     
          { path: "*", element: <Navigate to="/dashboard" />, index: true },  
        ],
      },
    ]
    : []),
        {
          path: "reset-password",
          element: makeLazyComponent(() => <ChangePassword />),
        },
        {
          path: "profile",
          element: makeLazyComponent(() => <MyAccount />),
        },
        {
          path: "settings",
          element: makeLazyComponent(() => <GlobalSetting />),
        },
        ...(hasPermission("Offer And Banner Management")
        ? [
        {
          path: "offer-and-banner-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <Offerandbannermanagement />),
            },
            { path: "add", element: makeLazyComponent(() => <AddBannerOffer />) },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <OfferAndBannerView />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddBannerOffer />),
            },
          ],
        }
      ]
      : []),
      ...(hasPermission("Category Management")
      ? [
        {
          path: "category-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <CategoryManagement />)
            },
            { path: "add", element: makeLazyComponent(() => <AddCategory />)},
            { path: "view/:id", element: makeLazyComponent(() => <CategoryView />)},
            {path: "edit/:id", element: makeLazyComponent(() => <AddCategory />)}
          ]

        },
      ]
      : []),
        ...(hasPermission("Product Management")
          ? [
        {
          path: "product-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <ProductManagement />)
            },
            { path: "add", element: makeLazyComponent(() => <AddProduct />)},
            { path: "view/:id", element: makeLazyComponent(() => <ProductView />)},
            {path: "edit/:id", element: makeLazyComponent(() => <AddProduct />)}
          ]
        },
      ]
      : []),
        ...(hasPermission("Dealer Management")
          ? [
        {
          path: "dealer-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <DealerManagement />)
            },
            { path: "add", element: makeLazyComponent(() => <AddDealer />)},
            { path: "view/:id", element: makeLazyComponent(() => <DealerView />)},
            {path: "edit/:id", element: makeLazyComponent(() => <AddDealer />)}
          ]
        },
      ]
      : []),
        ...(hasPermission("Customer Management")
          ? [
        {
          path: "customer-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <CustomerManagement />)
            },
            { path: "add", element: makeLazyComponent(() => <AddCustomer />)},
            { path: "view/:id", element: makeLazyComponent(() => <CustomerView />)},
            {path: "edit/:id", element: makeLazyComponent(() => <AddCustomer />)}
          ]
        },
      ]
      : []),
        ...(hasPermission("Order Management")
          ? [
        {
          path: "order-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <OrderManagement />)
            },
            { path: "view/:id", element: makeLazyComponent(() => <OrderManagementView />)},
          ]
        },
      ]
      : []),
        ...(hasPermission("Delivery Partner Management")
          ? [
        {
          path: "delivery-partner-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <DeliveryPartnerManagement />)
            },
            { path: "add", element: makeLazyComponent(() => <AddDeliveryPartner />)},
            { path: "view/:id", element: makeLazyComponent(() => <DeliveryPartnerManagementView />)},
            {path: "edit/:id", element: makeLazyComponent(() => <AddDeliveryPartner />)}
          ]
        },
      ]
      : []),
        ...(hasPermission("Payment Management")
          ? [
        {
          path: "payment-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <PaymentManagement />)
            },
            { path: "view/:id", element: makeLazyComponent(() => <PaymentManagementView />)},
          ]
        },
      ]
      : []),
        ...(hasPermission("Notification Management")
          ? [
        {
          path: "notification-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <NotificationManagement />)
            },
            { path: "add", element: makeLazyComponent(() => <NotificationEdit />)},
            { path: "edit/:id", element: makeLazyComponent(() => <NotificationEdit />)},
            { path: "view/:id", element: makeLazyComponent(() => <NotificationView />)}
          ]
          
        },
      ]
      : []),
        ...(hasPermission("Subadmin Management")
          ? [
        {
          path: "subadmin-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <SubAdminManagementList />)
            },
            { path: "add", element: makeLazyComponent(() => <AddEditSubadmin />)},
            { path: "view/:id", element: makeLazyComponent(() => <ViewSubAdminManagement />)},
            {path: "edit/:id", element: makeLazyComponent(() => <AddEditSubadmin />)}
          ]
        },
      ]
      : []),
        ...(hasPermission("Rate & Review Management")
          ? [
        {
          path: "rate-and-review-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <RateAndReviewList />)
            },
            { path: "view/:id", element: makeLazyComponent(() => <ViewRateAndReview />)},
          ]
        },
      ]
      : []),
        ...(hasPermission("Reports & Analytics Management")
          ? [
        {
          path: "reports-and-analytics-management",
          children: [
            { path: "dealer", element: makeLazyComponent(() => <DealerReport />)},
            { path: "driver", element: makeLazyComponent(() => <DriverReport />)},
            { path: "order", element: makeLazyComponent(() => <OrderReport />)},
            { path: "refund", element: makeLazyComponent(() => <RefundCancellationReport />)},
            { path: "userIssue", element: makeLazyComponent(() => <UserIssueReport />)},
            { path: "demographic", element: makeLazyComponent(() => <DemographicReport />)},
            { path: "revenue", element: makeLazyComponent(() => <RevenueReport />)},
            { path: "salesTrends", element: makeLazyComponent(() => <SalesTrendsReport />)},
          ]
        },
      ]
      : []),
      ...(hasPermission("Dealer Commission Management")
          ? [
        {
          path: "dealer-commission-management",
          children: [
            { index: true, element: makeLazyComponent(() => <List />),},
            { path: "view/:id", element: makeLazyComponent(() => <View />), },
          ],
        },
      ]
      : []),
      ...(hasPermission("Language Management")
          ? [
        {
          path: "language-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <LanguageList />)
            },
            { path: "add", element: makeLazyComponent(() => <AddLanguage />)},
            { path: "view/:id", element: makeLazyComponent(() => <DeliveryPartnerManagementView />)},
            {path: "edit/:id", element: makeLazyComponent(() => <AddDeliveryPartner />)}
          ]
        },
      ]
      : []),
      ...(hasPermission("Currency Management")
      ? [
        {
          path: "currency-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <CurrencySettings />)
            },
          ]
        },
      ]
      : []),
        ...(hasPermission("CMS Management")
          ? [
        {
          path: "cms",
          children: [
            { index: true, element: makeLazyComponent(() => <CmsPage />),},
            { path: "add", element: makeLazyComponent(() => <AddEditCms />), },
            { path: "edit/:id", element: makeLazyComponent(() => <AddEditCms />), },
            { path: "view/:id", element: makeLazyComponent(() => <ViewCms />), },
          ],
        },
      ]
      : []),
        ...(hasPermission("FAQ Management")
          ? [
        {
          path: "faq",
          children: [
            { index: true, element: makeLazyComponent(() => <FaqList /> )},
            { path: "add", element: makeLazyComponent(() => <AddEditFaq />) },
            { path: "edit/:id", element: makeLazyComponent(() => <AddEditFaq />) },
            { path: "view/:id", element: makeLazyComponent(() => <ViewFaqDetail />), },
          ]
        },
      ]
      : []),
      //   ...(hasPermission("Time Slot Management")
      //     ? [
      //   {
      //     path: "time-slot",
      //     children: [
      //       { index: true, element: makeLazyComponent(() => <TimeSlot />),},
      //       { path: "add", element: makeLazyComponent(() => <AddTimeSlot />), },
      //       { path: "edit/:id", element: makeLazyComponent(() => <AddTimeSlot />), },
      //       { path: "view/:id", element: makeLazyComponent(() => <TimeSlotView />), },
      //     ],
      //   },
      // ]
      // : []),
      ...(hasPermission("Customer Query Management")
      ? [
        {
          path: "customer-query-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <CustomerQueryManagement />)
            },
            { path: "view/:id", element: makeLazyComponent(() => <CustomerQueryView />)},
          ]
        },
      ]
      : []),
        ...(hasPermission("Email Template Management")
          ? [
        {
          path: "email-template",
          children: [
            {
              index: true,
              element: <EmailTemplateList />,
            },
            {
              path: "add",
              element: <AddEmail />,
            },

            {
              path: "edit/:id",
              element: <AddEmail />,
            },
            {
              path: "view/:id",
              element: <ViewEmail />,
            },
          ],
        },
      ]
      : []),
    ],
    },
   {
  path: "*",
  element: <Navigate to={getFirstPermittedRoute(permissions?.permission)} />,
}


  ];

  return useRoutes(routes);
};

export default MainRouting;